module.exports = __webpack_public_path__ + "media/4_3.92ff15ee.wav";